<template>
  <div :class="[$style.wrapper, 'dropzone']" :data-zone="user.id">
    <div :class="[$style.user, 'draggable', 'b-user']" :data-id="user.id">
      <div :class="[$style.avatar, 'b-user__avatar']" :style="{ backgroundImage: `url(${user.avatar})` }"></div>
      <div :class="[$style.name, 'user-name']">{{user.name}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'User',
  props: {
    user: Object,
  },
}
</script>
<style lang="scss" module>
@import './User.scss';
</style>
